import React from 'react';
import BrotherCardBase from './BrotherCardBase';

// Active member: profile under /members, subtitle is major + class year.
function BrotherCard(props) {
  const subtitle = props.major
    ? (props.year ? `${props.major}, Class of ${props.year}` : props.major)
    : (props.year ? `Class of ${props.year}` : undefined);

  return (
    <BrotherCardBase
      name={props.name}
      headshot={props.headshot}
      routePrefix="/members"
      subtitle={subtitle}
    />
  );
}

export default BrotherCard;
